var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "button",
    {
      staticClass: "sc-user-input--button-icon-wrapper",
      attrs: { disabled: _vm.disabled },
    },
    [
      _vm.newIcon
        ? _c("span", { staticClass: "material-icons sendIcon" }, [
            _vm._v(" send "),
          ])
        : _c(
            "icon-base",
            {
              attrs: {
                color: _vm.color,
                "icon-name": _vm.tooltip,
                height: "20",
                width: "20",
              },
            },
            [_vm._t("default")],
            2
          ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }